import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";

const useTeacherHome = () => {
    const uid = sessionStorage.getItem("uid") || "";
    const {readFirestoreOneDoc} = useFirestore();
    const [isBranchAccount, setIsBranchAccount] = useState(false);
    useEffect(() => {
        getIsBranchAccount();
    }, [uid])


    const getIsBranchAccount = async() => {
        const result = await readFirestoreOneDoc("User/Auth/Branch", uid).then(res => {
            if(res.exists()){
                return true;
            }
            return false;
        })
        setIsBranchAccount(result);
    }


    return {isBranchAccount}
}

export default useTeacherHome;